import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, Users, CreditCard, BarChart3, Settings, LogOut, Menu, QrCode } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Logo } from "@/components/brand/Logo";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutGrid, end: true, id: "nav-dashboard-link" },
  { to: "/admin/clienti", label: "Clienti", icon: Users, id: "nav-clients-link" },
  { to: "/admin/card", label: "Card", icon: CreditCard, id: "nav-cards-link" },
  { to: "/admin/qr", label: "QR da link", icon: QrCode, id: "nav-qr-links" },
  { to: "/admin/statistiche", label: "Statistiche", icon: BarChart3, id: "nav-analytics-link" },
  { to: "/admin/impostazioni", label: "Impostazioni", icon: Settings, id: "nav-settings-link" },
];

const SidebarBody = ({ onNavigate }) => {
  const { user, logout } = useAuth();
  return (
    <div className="flex h-full flex-col">
      <div className="px-6 pt-7 pb-8">
        <Logo size={30} />
        <div className="eyebrow mt-2.5">Studio</div>
      </div>
      <nav className="flex-1 space-y-0.5 px-3">
        {NAV.map(({ to, label, icon: Icon, end, id }) => (
          <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={id}
            className={({ isActive }) => `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors duration-150 ${isActive ? "bg-black/[0.06] font-medium text-black" : "text-zinc-500 hover:bg-black/[0.03] hover:text-black"}`}>
            <Icon className="h-4 w-4" strokeWidth={1.6} />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t px-4 py-4">
        <div className="truncate text-xs text-zinc-500" data-testid="sidebar-user-email">{user?.email}</div>
        <button onClick={logout} data-testid="logout-button" className="mt-2 flex items-center gap-2 text-sm text-zinc-700 hover:text-terra transition-colors">
          <LogOut className="h-4 w-4" strokeWidth={1.6} /> Esci
        </button>
      </div>
    </div>
  );
};

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <aside data-testid="admin-sidebar" className="fixed inset-y-0 left-0 hidden w-60 border-r border-black/[0.06] bg-white/80 backdrop-blur-xl lg:block">
        <SidebarBody />
      </aside>
      <div className="sticky top-0 z-30 flex items-center justify-between border-b bg-white/90 px-4 py-3 backdrop-blur lg:hidden">
        <Logo size={26} testId="brand-logo-mobile" />
        <button data-testid="mobile-menu-button" onClick={() => setOpen(true)} className="rounded-md border p-2"><Menu className="h-4 w-4" /></button>
      </div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-64 p-0"><SidebarBody onNavigate={() => setOpen(false)} /></SheetContent>
      </Sheet>
      <main className="lg:pl-60">
        <div className="mx-auto max-w-6xl px-5 py-8 sm:px-8 lg:px-12 lg:py-12"><Outlet /></div>
      </main>
    </div>
  );
}
